import emitter from "@/api/events";
import {ORDERS_LIMIT} from "@/constants";

export default {
    methods: {
        events_listen() {

            const orders = () => {

                return Promise.all([
                    this.$store.dispatch("user/constraints/fetch"),
                    this.$store.dispatch("user/constraints/fetchCart"),
                    this.$store.dispatch("user/orders/fetch", {
                        skip: 0,
                        limit: ORDERS_LIMIT,
                        transferred: "false"
                    }),
                ]);
            }

            emitter.on('user_order_submit', orders);
            emitter.on('user_order_cancel', orders);
            emitter.on('user_order_received', orders);
            emitter.on('user_order_not_received', orders);
            emitter.on('user_order_undo', orders);
            emitter.on('user_order_hide', orders);
            emitter.on('user_order_transfer', orders);
        }
    }
}